// Figma: no frame provided for this section yet — built using the established design
// system (same layout shell as ../DashboardPage.js's TodayDashboard) per the "extrapolate"
// decision.
// LOGIC PORTED from LC2's CommunityTab.js (commons/components/HomeTabs/Today/Community/
// CommunityTab.js) — same composition: community-scoped stat cards, the resident action
// feed, "at a glance" (../Glance/GlanceSection.js, ported from LC2's Portfolio/Glance/
// Glance.js — LC2's CommunityTab reuses the same Glance component as PortfolioTab, and it
// self-scopes off `params.community_sfid` the same way here), the campaigns table (both
// already scope themselves to `params.community_sfid`, see ../ResidentActionFeedTable.js /
// ../CampaignsTable.js), and alerts (../AlertsSection.js, same).
//
// This renders both for the sidebar's "Communities" tab AND for any `community_sfid` route
// regardless of which sidebar tab is selected — see DashboardPage.js, mirroring LC2 where
// the URL (not the tab) decided whether CommunityTab or PortfolioTab rendered.
import React from 'react';
import {Box, Stack} from '@mui/material';

import CommunityStatCards from './CommunityStatCards';
import SectionNav from '../SectionNav';
import ResidentActionFeedTable from '../ResidentActionFeedTable';
import CampaignsTable from '../CampaignsTable';
import AlertsSection from '../AlertsSection';
import GlanceSection from '../Glance/GlanceSection';

const CommunitySection = () => (
    <Stack spacing={3}>
        <CommunityStatCards />
        <SectionNav />
        <Box id="resident-action-feed">
            <ResidentActionFeedTable />
        </Box>
        <Box id="at-a-glance">
            <GlanceSection />
        </Box>
        <Box id="campaigns">
            <CampaignsTable />
        </Box>
        <Box id="alerts">
            <AlertsSection />
        </Box>
    </Stack>
);

export default CommunitySection;
